import http from "@/http/aisea/axios";
const resource = "/vessel_report/enterprise/vessels";

export default {
  fetch(payload) {
    return http.get(`${resource}/${payload.vesselId}/reports/${payload.id}`);
  },
  fetchList(payload) {
    return http.get(`${resource}/${payload.path.vesselId}/reports`, {
      params: payload.params
    });
  },
};
